var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33337 4.50065H6.66671C6.02671 4.50065 4.83337 4.50065 4.83337 2.66732C4.83337 0.833984 6.02671 0.833984 6.66671 0.833984H9.33337C9.97337 0.833984 11.1667 0.833984 11.1667 2.66732C11.1667 3.30732 11.1667 4.50065 9.33337 4.50065ZM6.66671 1.83398C6.00671 1.83398 5.83337 1.83398 5.83337 2.66732C5.83337 3.50065 6.00671 3.50065 6.66671 3.50065H9.33337C10.1667 3.50065 10.1667 3.32732 10.1667 2.66732C10.1667 1.83398 9.99337 1.83398 9.33337 1.83398H6.66671Z",
    fill: "#4C4C4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 15.1662H6C2.25333 15.1662 1.5 13.4462 1.5 10.6662V6.66616C1.5 3.62616 2.6 2.32616 5.30667 2.18616C5.56667 2.17282 5.82 2.37949 5.83333 2.65949C5.84667 2.93949 5.63333 3.16616 5.36 3.17949C3.46667 3.28616 2.5 3.85282 2.5 6.66616V10.6662C2.5 13.1328 2.98667 14.1662 6 14.1662H9.33333C9.60667 14.1662 9.83333 14.3928 9.83333 14.6662C9.83333 14.9395 9.60667 15.1662 9.33333 15.1662Z",
    fill: "#4C4C4C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9999 10.5003C13.7266 10.5003 13.4999 10.2736 13.4999 10.0003V6.66695C13.4999 3.85361 12.5333 3.28695 10.6399 3.18028C10.3666 3.16695 10.1533 2.92695 10.1666 2.65361C10.1799 2.38028 10.4199 2.16695 10.6933 2.18028C13.3999 2.32695 14.4999 3.62695 14.4999 6.66028V9.99361C14.4999 10.2736 14.2733 10.5003 13.9999 10.5003Z",
    fill: "#4C4C4C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.166C9.72667 13.166 9.5 12.9393 9.5 12.666V10.666C9.5 10.3927 9.72667 10.166 10 10.166H12C12.2733 10.166 12.5 10.3927 12.5 10.666C12.5 10.9393 12.2733 11.166 12 11.166H10.5V12.666C10.5 12.9393 10.2733 13.166 10 13.166Z",
    fill: "#292D32"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 15.167C13.8733 15.167 13.7467 15.1203 13.6467 15.0203L9.67332 11.047C9.47999 10.8536 9.47999 10.5336 9.67332 10.3403C9.86665 10.147 10.1867 10.147 10.38 10.3403L14.3533 14.3136C14.5467 14.507 14.5467 14.827 14.3533 15.0203C14.2533 15.1203 14.1267 15.167 14 15.167Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportIcon);
export default __webpack_public_path__ + "static/media/export-icon.22469fecfa54192549d4195851f47f1c.svg";
export { ForwardRef as ReactComponent };